// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
//COMPONENTS
//SERVICES AND HELPERS
import constants from '../../constants/constants';
import * as dashboardService from '../../services/dashboard/dashboardService';
import { start } from '../../services/form/plmChainOfCustodyService';
import { DescriptionTwoTone } from '@material-ui/icons';

const initialState = {
    jobId: 0,
    start: '',
    end: '',
    userId : 0,
    projectNumber: ''
}

const Agenda = (props) => {
    let history = useHistory();
    const { description, imageUrl, userId, switchMode, jobId, start, end, refresh, projectNumber, userFullName } = props.event;
    let descriptionWithoutProjectNumber = description.split(':');
    const [modalOpen, setModalOpen] = useState(false);
    const [refreshCalendar, setRefreshCalendar] = useState(refresh);
    const [descriptionTo, setDescriptionTo] = useState(descriptionWithoutProjectNumber.length > 1 ? descriptionWithoutProjectNumber[1].split('--').length >1 ? 
    descriptionWithoutProjectNumber[1].split('--')[0] : descriptionWithoutProjectNumber[1] :  '');
    const [agendaModel, setAgendaModel] = useState({
        ...initialState,  jobId: jobId, projectNumber: projectNumber, start: moment(start).format('YYYY-MM-DD HH:mm:ss'), end: moment(end).format('YYYY-MM-DD HH:mm:ss'), userId: userId, description: description
    })
    

    useEffect(() => {
    }, [])

    const handleModalClose = () => {
        setModalOpen(false)
    }

    const handleUpdateDescription = () => {
        console.log({ ...agendaModel, description: descriptionTo})
        dashboardService.updateDescription({ ...agendaModel, description: descriptionTo}).then(res => {
            props.event.description = `# ${agendaModel.projectNumber}: ${descriptionTo}`;
            if(userFullName){
                props.event.description = `${props.event.description} -- ${userFullName}`
            }
        }).finally(() => {
            handleModalClose();
        })
    }

    return (
        <>
            <span onClick={() => setModalOpen(true)}>{description}</span>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {
                    switchMode &&
                    <img alt="User"
                        src={`https://aesapi.primtek.net/${imageUrl}`}
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                        onClick={() => window.open(`${constants.PORTAL_URL}/management/user-profile/${userId}`)}
                    >
                    </img>
                }
            </div>

            <Modal centered size="lg" show={modalOpen} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Description</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="form-group row">
                                <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Description
                                </label>
                                <div className="col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Description"
                                        className={`form-control form-control-lg form-control-solid`}
                                        onChange={(e)=> {
                                            setDescriptionTo(e.target.value)
                                        }}
                                        name="description"
                                        value={descriptionTo}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    <button
                        type="submit"
                        className="btn btn-success mr-2"
                        onClick={handleUpdateDescription}
                    >
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>




    );
};

export default Agenda;
